import { requestBridge, startRelay } from '../actions';
import { PortalConfig } from '../types';
import { PostMessagePortal } from './PostMessagePortal';

const PARENT_WINDOW = (window.opener || window.parent) as Window;

interface SourcePortalConfig {
  portalConfig: PortalConfig;
  externalWindow?: Window;
  currentWindow?: Window;
  debug?: boolean;
  logTag?: string;
}

export class SourcePortal extends PostMessagePortal {
  constructor({
    portalConfig,
    currentWindow = window,
    externalWindow = PARENT_WINDOW,
    logTag = 'bridge-source',
    debug = false,
  }: SourcePortalConfig) {
    super({ portalConfig, externalWindow, currentWindow, logTag, debug });

    // Request bridge to ardoq-front
    this.postMessageOverBridge(
      requestBridge({ portalConfigId: portalConfig.id })
    );

    // Immediately post action to announce that ardoq-front can start sending
    // actions that will be dispatched into our action stream.
    this.postMessageOverBridge(startRelay({ portalConfigId: portalConfig.id }));
  }
}
